import { JoiApiUrl } from 'Utils/Utils';

// No Authorization header — this endpoint doesn't require one, unlike the
// rest of the app's API calls, so this deliberately doesn't go through
// fetchClient's authFetch.
export const atlasApi = {
  getUserId: async (email: string): Promise<{ user_id?: string } | null> => {
    const res = await fetch(`${JoiApiUrl()}/data/v1/get_user_id?email=${encodeURIComponent(email)}`);
    if (!res.ok) return null;
    return res.json();
  },
};
